import { render } from "./DButton.vue?vue&type=template&id=bf838102&scoped=true"
import script from "./DButton.vue?vue&type=script&lang=js"
export * from "./DButton.vue?vue&type=script&lang=js"

import "./DButton.vue?vue&type=style&index=0&id=bf838102&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf838102"]])

export default __exports__